import React from 'react';
import { useTranslation } from 'react-i18next';
import './../../scss/components/invoice-status-badge.style.scss';

interface InvoiceStatusBadgeProps {
  status: 'paid' | 'not-paid' | 'overdue';
  className?: string;
}

export const InvoiceStatusBadge: React.FC<InvoiceStatusBadgeProps> = ({
  status,
  className = ''
}) => {
  const { t } = useTranslation();
  const getStatusText = (status: string) => {
    switch (status) {
      case 'paid':
        return t('PAID');
      case 'not-paid':
        return t('NOT_PAID');
      case 'overdue':
        return t('OVERDUE');
      default:
        return status;
    }
  };

  return (
    <div className={`invoice-status-badge invoice-status-badge--${status} ${className}`}>
      <span className="invoice-status-badge__dot" aria-hidden="true" />
      <span className="invoice-status-badge__text">
        {getStatusText(status)}
      </span>
    </div>
  );
};
